import isURL from "validator/lib/isURL";

export const getImageUrl = (imageId: string) =>
  isURL(imageId) ? imageId : `https://pub-4b15203a4a0f4b26ab71deeffce0164a.r2.dev/${imageId}`;
